export default "__VITE_ASSET__233f2257__"